import styled from 'styled-components';

const StyledPage = styled.div`
    font-family: 'Roboto', 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue';
`;

export default StyledPage;
